/*@flow*/

type LatLon = [number, number];

export default function geocode(latlon: LatLon): Promise<?string> {
  return new Promise((res, rej) => {
    if (!window.google) {
      rej('Google API not loaded.');
    }
    const geocoder = new window.google.maps.Geocoder();
    const latlng = { lat: parseFloat(latlon[0]), lng: parseFloat(latlon[1]) };
    geocoder.geocode({ location: latlng }, (results, status) => {
      if (status === 'OK') {
        if (results[0]) {
          const address = results[0].formatted_address;
          res(address);
        } else {
          rej('No results found');
        }
      } else {
        rej('Geocoder failed due to: ' + status);
      }
    });
  });
}
